import type { FormEventHandler } from "react";
import useTranslator from "../../hooks/useTranslator";
import AuthStepHeader from "./AuthStepHeader";
import { Button, Icon, TextField } from "../design";
import { useNavigate } from "react-router-dom";
import type { AccountType } from "../../pages/auth/authFlow";
import "./AuthForm.css";

interface EmailFormProps {
  usedFor: AccountType;
  email: string;
  onChangeHandler: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled: boolean;
  emailSubmitHandler: FormEventHandler<HTMLFormElement>;
  loading?: boolean;
  companyLogo?: string | null;
  from?: string | null;
  isInvitedEmail?: boolean;
}

const EmailForm = ({
  usedFor,
  email,
  onChangeHandler,
  disabled,
  emailSubmitHandler,
  loading = false,
  from,
  isInvitedEmail,
}: EmailFormProps) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const isTenant = usedFor === "tenant";

  return (
    <div className="auth-step">
      <AuthStepHeader
        onBack={() =>
          from === "website"
            ? window.location.replace("https://skortorent.com/")
            : navigate("/auth")
        }
        pill={{
          icon: isTenant ? "/images/kyc.svg" : "/images/home.svg",
          label: isTenant ? _t("tenant") : _t("landlord"),
        }}
        title={_t("whatsYourEmail")}
        subtitle={
          isTenant
            ? _t(
                "helpingUsersBuildProfileForFasterApprovalsFromLandlordsAndAgentsToHelpThemMakeTheirDreamPlaceHome"
              )
            : _t("helpingLandlordsShowcasePropertiesForQuickerUserMatches")
        }
      />
      <form onSubmit={emailSubmitHandler}>
        <TextField
          id="auth-email"
          name="email"
          icon={<Icon name="mail" />}
          label={_t("emailAddress")}
          placeholder="name@example.com"
          value={email}
          onChange={onChangeHandler}
          disabled={disabled || isInvitedEmail}
          required
        />
        <Button
          type="submit"
          size="lg"
          block
          disabled={disabled}
          loading={loading}
          iconEnd={<Icon name="arrowRight" size={18} />}
        >
          {_t("getStarted")}
        </Button>
      </form>
      <p className="auth-footer">
        {_t("doYouWantToContinueAs")}{" "}
        <Button
          variant="link"
          onClick={() => navigate(isTenant ? "/landlord/auth" : "/tenant/auth")}
        >
          {isTenant ? _t("landlord") : _t("tenant")}
        </Button>
      </p>
    </div>
  );
};

export default EmailForm;
